import axios from "axios";

const instance = axios.create({
  timeout: 100000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    // Authorization: `Bearer ${localStorage.getItem("token") ? localStorage.getItem("token") : ""}`,
  }
});

export default instance;
